import { useContextState } from "../../../../../../../../hooks/theme"

export const useStyles = () => {
  const { colors: color } = useContextState()
  return {
    userSelected: ({ haveUser }: { haveUser: boolean }) => ({
      color: haveUser ? color.color1 : color.color13
    }),
    content: {
      padding: '0 20px',
      paddingTop: '20px',
    },
    contentRight: {
      overflowY: 'auto',
      maxHeight: 'calc(90vh - 110px)'
    },
    createTitle: {
      paddingBottom: '0px',
      lineHeight: '1',
      padding: '20px 20px 0',
    },
    permissionTable:{
      padding: '20px',
      paddingBottom: '0px',
    },
    footerBtn: {
      marginTop: "20px",
      paddingTop: '0px',
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: '0 20px 20px',
    },
    containerButton:{
      display:'flex',
      alignItems: 'center',
      gap: 2
    },
    goBack: {
      display: 'flex',
      justifyContent: 'flex-start',
      '& .MuiSvgIcon-root': {
        fontSize: '1.4rem',
        color: color.color4,
      },
    },
    alignItems: {
      width: '100%',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginRight: 2,
      '& .MuiTypography-root': {
        fontSize: '14px'
      },
      marginBottom:2
    },
  }
}
